import { useParams } from "react-router-dom";
import { courseRegistry } from "../../courses/courseRegistry";



export default function CourseEbooks({ user, accessibleLevels}) {
  const { courseSlug } = useParams();
  const course = courseRegistry[courseSlug];
 

  if (!course) return <div>Course Not Found</div>
  const EbookComponent = course.ebookComponent;
  if (!EbookComponent) return <div>No ebooks available</div>;

  return (
  <EbookComponent
     user={user}
    accessibleLevels={accessibleLevels} />);
}